import React from 'react';
import PropTypes from 'prop-types';

import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';

function ChartHeader({ children }) {
  return (
    <Grid size={{ xs: 12, width: '100%' }}>
      <Card raised sx={{ px: 1, py: 0.5, width: '100%' }}>
        <Stack
          direction='row'
          justifyContent='space-evenly'
          alignItems='center'
          sx={{ width: '100%' }}
          divider={
            <Divider orientation='vertical' flexItem sx={{ mt: 1, mb: 1 }} />
          }>
          {children}
        </Stack>
      </Card>
    </Grid>
  );
}

ChartHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChartHeader;
